var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenFileDesk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_161_125",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_161_125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 10.75C19.9999 9.35218 19.9999 8.40326 19.7715 7.85195C19.4671 7.11687 18.883 6.53284 18.148 6.22836C17.5966 6 16.8977 6 15.4999 6C14.4713 6 13.4427 6 12.4141 6C12.2455 6 12.1612 6 12.08 5.99559C11.3975 5.95855 10.7481 5.68957 10.2393 5.23317C10.1787 5.17884 10.1191 5.11923 9.99988 5C9.88065 4.88077 9.82104 4.82116 9.76048 4.76683C9.25169 4.31043 8.60231 4.04145 7.91982 4.00441C7.83859 4 7.75428 4 7.58567 4C7.32374 4 7.06181 4 6.79988 4C5.11972 4 4.27964 4 3.63791 4.32698C3.07342 4.6146 2.61448 5.07354 2.32686 5.63803C1.99988 6.27976 1.99988 7.11984 1.99988 8.8C1.99988 10.9333 1.99988 13.0667 1.99988 15.2C1.99988 16.8802 1.99988 17.7202 2.32686 18.362C2.61448 18.9265 3.07342 19.3854 3.63791 19.673C4.27964 20 5.11972 20 6.79988 20C8.19988 20 9.59988 20 10.9999 20",
    stroke: "#10A37F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33784 12C6.33784 12 3.70065 14.3649 3.32673 15.8829C2.95281 17.4009 2.99975 17.9553 3.32673 18.5309C3.61435 19.0372 4.07329 19.4488 4.63778 19.7067C5.27951 20 6.11959 20 7.79975 20C10.5998 20 13.3998 20 16.1998 20C17.88 20 18.079 20 18.7208 19.7067C19.2853 19.4488 19.7442 19.0372 20.0318 18.5309C20.2008 18.2334 20.3759 17.2957 20.9497 15.8829C21.4859 14.5627 22.4063 12.7814 22.9998 12H6.33784Z",
    stroke: "#10A37F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenFileDesk);
export default __webpack_public_path__ + "static/media/GreenFileDesk.95711e965a843110db30887974b6cd7f.svg";
export { ForwardRef as ReactComponent };